import { render } from "./client-list.vue?vue&type=template&id=4efe39f4&lang=html"
import script from "./client-list.vue?vue&type=script&lang=js"
export * from "./client-list.vue?vue&type=script&lang=js"

import "./client-list.vue?vue&type=style&index=0&id=4efe39f4&lang=less"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__